import { Tabs } from "antd";
import BranchesDetails from "./VendorInformationTabs/BranchesDetails";
import VendorPersonalDetails from "./VendorInformationTabs/VendorPersonalDetails";
import BankDetail from "./VendorInformationTabs/BankDetail";
import Settings from "./VendorInformationTabs/Settings";
import WalletHistory from "./VendorInformationTabs/WalletHistory";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
const VendorInformation = () => {
  let { id } = useParams();
  let getItem = localStorage.getItem("currentTab");
  const [defaultIndex, setDefaultIndex] = useState(getItem ? getItem : "1");
  const [walletToggle, setWalletToggle] = useState(false);

  useEffect(() => {
    return () => {
      localStorage.removeItem("currentTab");
    };
  }, []);

  const onTabChange = (key) => {
    setDefaultIndex(key);
  };

  return (
    <>
      <Tabs activeKey={defaultIndex} onChange={onTabChange}>
        <Tabs.TabPane tab={"Personal details"} key={1}>
          <VendorPersonalDetails setWalletToggle={setWalletToggle} />
        </Tabs.TabPane>
        {id ? (
          <>
            <Tabs.TabPane tab={"Branches details"} key={2}>
              <BranchesDetails />
            </Tabs.TabPane>
            <Tabs.TabPane tab={"Bank detail"} key={3}>
              {/* <PayoutDetails /> */}
              <BankDetail />
            </Tabs.TabPane>
            <Tabs.TabPane tab={"Settings"}  key={4}>
              <Settings walletToggle={walletToggle} setWalletToggle={setWalletToggle} setDefaultIndex={setDefaultIndex} />
            </Tabs.TabPane>
          </>
        ) : null}
        
        {walletToggle && <Tabs.TabPane tab={"Wallet"} key={6}>
          <WalletHistory userId={id} />
        </Tabs.TabPane>}
      </Tabs>
    </>
  );
};
export default VendorInformation;
